import { RouteComponentProps } from '@reach/router';
import { Card, CardBody } from 'components/atoms/card';
import { H3, Paragraph } from 'components/atoms/text';
import { useHeader } from 'contexts/headerContext';
import { SendAgreementTaskMailInputModel, AgreementType } from 'hooks/agreement/types';
import useAgreements from 'hooks/agreement/';
import { FormGroup, FormikFormFile, FormikFormTextarea, FormikFormControl } from 'components/atoms/form';
import { Form, Formik, FormikHelpers } from 'formik';
import { toFormikErrors } from 'utils/errorhelper';
import { toast } from 'react-toastify';
import { Button } from 'components/atoms/button';
import React, { FC } from 'react';

interface TranslationProps extends RouteComponentProps { }

const initialValues: SendAgreementTaskMailInputModel = {
    file: undefined,
    comments: '',
    type: AgreementType.Translation,
    language: ''
};

const CaTranslation: FC<TranslationProps> = () => {
    useHeader('Overeenkomsten');

    const { sendAgreementTaskMail } = useAgreements();


    const handleMail = async (values: SendAgreementTaskMailInputModel, { setErrors, resetForm }: FormikHelpers<SendAgreementTaskMailInputModel>) => {
        const response = await sendAgreementTaskMail(values);

        if (response.ok) {
            toast.success('Uw aanvraag voor vertaling is succesvol verstuurd');
            resetForm();
        } else if (response.errors) {
            const errors = toFormikErrors<SendAgreementTaskMailInputModel>(response.errors);
            setErrors(errors);
        } else {
            toast.error('Er ging iets fout bij het versturen van de vertaal-aanvraag');
        }
    };

    return (
        <>
            <Card variant="primary">
                <CardBody>
                    <H3 variant="white">Vertalen overeenkomst</H3>
                    <Paragraph variant="white">
                        Doet u ook zaken in het buitenland? Met een vertaling van uw overeenkomst zijn ook uw internationale klanten op de hoogte van de voorwaarden waaronder u zoeken doet.
                    </Paragraph>
                    <Paragraph variant="white" noMargin>
                        Vul onderstaand formulier in en u ontvangt een vrijblijvende prijsopgave.
                    </Paragraph>
                </CardBody>
            </Card>
            <Card>
                <CardBody>
                    <Formik<SendAgreementTaskMailInputModel> initialValues={initialValues} onSubmit={handleMail}>
                        {({ isSubmitting }) => (
                            <Form>
                                <FormGroup label="Bijlage toevoegen" required>
                                    <FormikFormFile name="file" />
                                </FormGroup>
                                <FormGroup label="Taal" required>
                                    <FormikFormControl name="language" />
                                </FormGroup>
                                <FormGroup label="Vraag of opmerking">
                                    <FormikFormTextarea name="comments" placeholder="Opmerking" />
                                </FormGroup>
                                <FormGroup noMargin alignRight>
                                    <Button loading={isSubmitting}>Verzenden</Button>
                                </FormGroup>
                            </Form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </>
    );
};

export default CaTranslation;
